import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: "admin" | "employee" | "super_admin";
  cloudOnly?: boolean; // 👈 special flag for /cloud-storage route
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredRole,
  cloudOnly = false,
}) => {
  const { auth } = useAuth();
  const location = useLocation();
  const tfaVerified = localStorage.getItem("tfa_verified") === "true";

  // Show loading spinner while checking authentication
  if (auth.isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        Loading...
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!auth.isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const { role, istotpenabled, is_cloud_active } = auth.user || {};

  // TFA check
  if (
    (role === "admin" || role === "super_admin") &&
    istotpenabled &&
    !tfaVerified
  ) {
    return <Navigate to="/verify-tfa" />;
  }

  // 🔹 Super Admin bypasses cloud restrictions
  if (role === "super_admin") {
    if (requiredRole && role !== requiredRole) {
      return <Navigate to="/dashboard" replace />;
    }
    return <>{children}</>;
  }

  // 🔹 Employee restrictions
  if (role === "employee") {
    // Employees can *only* access cloud routes and only if cloud is active
    //if (!cloudOnly || !is_cloud_active) {
      //return <Navigate to="/dashboard" replace />;
    //}
    return <>{children}</>;
  }

  // 🔹 Admin restrictions
  if (role === "admin") {
    // For cloud-only routes → must have cloud active
    if (cloudOnly && !is_cloud_active) {
      return <Navigate to="/dashboard" replace />;
    }

    // If specific role required (like employees/settings)
    if (requiredRole && role !== requiredRole) {
      return <Navigate to="/dashboard" replace />;
    }

    return <>{children}</>;
  }

  // Default redirect
  return <Navigate to="/dashboard" replace />;
};

export default ProtectedRoute;
